export function key<T>(keyName: keyof T) {
  return keyName
}
